export default "__VITE_ASSET__00406147__"